import Container from "@mui/material/Container";
import { useState } from "react";
import DataNotFound from "../../../components/DataNotFound.js";
import ErrorDialog from "../../../components/dialogs/ErrorDialog.js";
import LoadingBackdrop from "../../../components/LoadingBackdrop.js";
import PageList from "../../../components/page-list/PageList.js";
import { useUser } from "../../../components/UserContext.js";
import { getEmployees } from "../../../lib/apiConfig.js";
import { PAGE_LIST_CONTAINER_SX } from "../../../lib/constants.js";
import { useFetch } from "../../../lib/hooks/useFetch.js";

export default function EmployeesList({ locales }) {
  const { runId } = useUser();
  const [employees, setEmployees] = useState(null);
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const { isFetching } = useFetch({
    endpoint: getEmployees({ runId }),
    mustFetch: !employees,
    onSuccess: setEmployees,
    onFail: (error) => {
      setErrorMessage(error.message);
      setShowError(true);
    },
  });

  return isFetching ? (
    <LoadingBackdrop />
  ) : (
    <Container disableGutters sx={PAGE_LIST_CONTAINER_SX}>
      {Array.isArray(employees) ? (
        <PageList
          items={employees}
          locales={locales}
          pageName="employees"
          primaryTextProp="name"
          searchBoxLabel={locales["security.employees.search"]}
          secondaryTextProp="department"
        />
      ) : (
        <DataNotFound text={locales["security.employees.notFound"]} />
      )}
      <ErrorDialog
        locales={locales}
        message={errorMessage}
        onClose={() => {
          setShowError(false);
          setErrorMessage(null);
        }}
        show={showError}
      />
    </Container>
  );
}
